export enum defaultFields {
    POSITION = 'position',
    SELECT = 'select',
}
